function Instructions() {
  return (
    <div className="Instructions">
      <h3>How to play</h3>
      <p>Click on any Pokémon to begin.</p>
      <p>Don't click on any Pokémon twice!</p>
      <p>Can you catch all 12 Pokémon?</p>
    </div>
  );
}

export default Instructions;
